module.exports = __webpack_public_path__ + "static/media/baner-podcasty.6400a89e.jpg";